import { 
  collection, doc, getDocs, setDoc, addDoc, updateDoc, deleteDoc, query, where, orderBy, serverTimestamp 
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase';

export const getAllBlogs = async () => {
  const q = query(collection(db, 'blogs'), orderBy('date', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const getPublishedBlogs = async () => {
  const q = query(collection(db, 'blogs'), where('status', '==', 'published'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const createBlog = async (data) => {
  const payload = {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    viewCount: 0,
    likeCount: 0,
  };
  if (data.slug) {
    await setDoc(doc(db, 'blogs', data.slug), payload);
    return data.slug;
  }
  const refDoc = await addDoc(collection(db, 'blogs'), payload);
  return refDoc.id;
};

export const updateBlog = async (id, data) => {
  await updateDoc(doc(db, 'blogs', id), { ...data, updatedAt: serverTimestamp() });
};

export const deleteBlog = async (id) => {
  await deleteDoc(doc(db, 'blogs', id));
};

export const uploadBlogImage = async (file, folder = 'blog-images') => {
  const storageRef = ref(storage, `${folder}/${Date.now()}-${file.name}`);
  const snapshot = await uploadBytes(storageRef, file);
  const url = await getDownloadURL(snapshot.ref);
  return url;
};


